import { useInfiniteRequest } from 'src/hook/useInfinityRequest'
import { getUserPostsByUcode } from 'src/client/user'
import { DEFAULT_CACHE_CONFIG } from 'src/services/constants'
import { POSTS_PER_PAGE } from './useGetUserPosts.constants'
import { UseGetUserPostsProps } from './useGetUserPosts.types'

const useGetUserPosts = ({
  ucode,
  rows = POSTS_PER_PAGE,
  pageToken = '',
  enabled
}: UseGetUserPostsProps) => {
  const cacheKey = `ucode:${ucode}-rows:${rows}-pageToken:${pageToken}`

  /* istanbul ignore next */
  const fetchData = async ({ pageParam }) => {
    const data = await getUserPostsByUcode({ ucode, rows, pageToken: pageParam })

    return data
  }

  const response = useInfiniteRequest(['getUserPostsByUcode', cacheKey], fetchData, {
    enabled,
    ...DEFAULT_CACHE_CONFIG,
    getNextPageParam: /* istanbul ignore next */ (lastPage) => {
      return lastPage?.nextPageToken
    }
  })

  return {
    ...response,
    isLoading: enabled ? response.isLoading : false
  }
}

export default useGetUserPosts
